import { defineStore } from 'pinia';

export const useNotificacionesStore = defineStore('notificaciones', {
  state: () => ({
    activas: false,   // si el usuario ya las activó
    token: null,      // token FCM
    nueva: false,     // indicador de nueva notificación
  }),

  actions: {
    activar(token = null) {
      this.activas = true;
      if (token) this.token = token;
      localStorage.setItem('notificaciones', JSON.stringify({
        activas: this.activas,
        token: this.token
      }));
    },
    desactivar() {
      this.activas = false;
      this.token = null;
      localStorage.removeItem('notificaciones');
    },
    marcarComoNueva() {
      this.nueva = true;
    },
    leer() {
      this.nueva = false;
    },
    cargarDesdeLocal() {
      const data = localStorage.getItem('notificaciones');
      if (data) {
        const { activas, token } = JSON.parse(data);
        this.activas = activas;
        this.token = token;
      }
    }
  }
});
